import { useEffect } from 'react'
import { useIsPortaledDialogOpen } from '../components/shared/Dialog'

/**
 * Closes an overlay on Escape while it is the topmost one, yielding to
 * anything portaled above it — a variant picker opened from inside the overlay
 * owns the keystroke first.
 *
 * `dismiss` is a dependency of the listener, so callers should pass a stable
 * reference.
 */
export const useEscapeToDismiss = (
    active: boolean,
    dismiss: () => void,
): void => {
    const isPortaledDialogOpen = useIsPortaledDialogOpen()

    useEffect(() => {
        if (!active) return
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key !== 'Escape' || isPortaledDialogOpen()) return
            dismiss()
        }
        window.addEventListener('keydown', onKeyDown)
        return () => window.removeEventListener('keydown', onKeyDown)
    }, [active, dismiss, isPortaledDialogOpen])
}
